

















import SettingsNavigation from "@/employer/components/settings/SettingsNavigation.vue";
import MfaSettings from "@/shared/components/MfaSettings.vue";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { Vue, Component } from "@/shared/vuepack";

@Component({
  components: {
    SettingsNavigation,
    MfaSettings,
    OktaFactorSettings
  }
})
export default class Security extends Vue {
  featureFlagStore = useFeatureFlagStore();
  userStore = useUserStore();

  get isOktaLoginEnabled () {
    return this.featureFlagStore.flags.bend23884EmpPortalOktaLogin;
  }
}
